module.exports = __webpack_public_path__ + "img/unimed.a349d90b.png";